/**
 * Event-name and content predicates the replay loop's frame step uses. Feature ids are never
 * hardcoded (fs_2, fs_3, …): a frame is any event with grid content or a feature enter / exit.
 */
export function isFeatureEnterExitEventTypeName(eventTypeName: string): boolean {
    return eventTypeName === "feature_enter" || eventTypeName === "feature_exit";
  }
  
  /**
   * A "frame event" is any event that carries a new visible grid state,
   * or at least reel stops that a game might want to display.
   *
   * This is intentionally permissive and is used as a fallback.
   */
  export function hasGridFrameContent(roundEventContent: {
    encodedGridSnapshot?: unknown;
    reelStopIndices?: unknown;
  }): boolean {
    const hasEncodedGridSnapshot = typeof roundEventContent.encodedGridSnapshot === "string";
  
    const hasReelStops =
      Array.isArray(roundEventContent.reelStopIndices) && roundEventContent.reelStopIndices.length > 0;
  
    return hasEncodedGridSnapshot || hasReelStops;
  }